import axios from "axios";

export default function ReceiptDownloadPdfService(receiptId) {
  return axios.get(process.env.REACT_APP_API_HOST + "/receipt/" + receiptId + "/downloadPdf", {
    responseType: 'blob',
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
};
